import React from "react";
import '../css/ModalAnnulationModif.css'

const ModalAnnulationModifs = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null; // Ne pas afficher le modal si isOpen est false

  return (
    <div className="modal_annulation_background">
      <div className="modal_annulation_contenu">
        <h2>Confirmation</h2>
        <p>Êtes-vous sûr de vouloir annuler vos modifications ?</p>
        <div className="modal_annulation_boutons">
          <button onClick={onClose} className="modal_annulation_bouton">Annuler</button>
          <button onClick={onConfirm} className="modal_annulation_bouton">Oui</button>
        </div>
      </div>
    </div>
  );
};

export default ModalAnnulationModifs;
